import { getMoscowDateTime } from './getMoscowDateTime'

//Диапазон по умолчанию считается по московскому времени, независимо от таймзоны браузера
export const getDefaultDateRange = () => {
  const startDate = getMoscowDateTime()
  startDate.setHours(0, 0, 0, 0) // 00:00:00.000 сегодня

  const endDate = new Date(startDate)
  endDate.setDate(endDate.getDate() + 1) // 00:00 завтра

  return {
    startDate,
    endDate,
  }
}
